<script>
  import formatDate from '@utils/format-date'
  import formMixin from "./mixins/form";

  const DEFAULT_SUBMIT_DATA = {
    meals: [],
  };

  export default {
    components: {
      
    },
    mixins: [formMixin],
    props: {
      value: {
        type: Object,
        default: () => {
          return { ...DEFAULT_SUBMIT_DATA }
        },
      },
      cartItem: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        
      }
    },
    methods: {
      formatDate,
      onSubmit() {
        this.$emit('submit');
      },
      onPrev() {
        this.$emit('prev');
      },
    }
  }
</script>
<template>
  <ValidationObserver ref="observer" v-slot="{ invalid, handleSubmit }">
    <el-form
      ref="form"
      :model="FormMixSubmitData"
      class="isStyleBase"
      label-position="top"
      @submit.prevent.native="handleSubmit(onSubmit)"
    >
      <div :class="$style.formApplyStep1">
        <div class="globalWhiteBox mb-5">
          <div class="globalWhiteBox__inner">
            <h2 class="text-center text-2xl mb-3">選取餐食</h2>
            <p
              v-if="!!cartItem.mealDescription"
              class="text-gray-5"
            >
              {{ cartItem.mealDescription }}
            </p>
            <hr>
            <div :class="$style.mealList">
              <template v-for="(mealItem, index) in cartItem.meals">
                <div
                  v-if="!!mealItem.meal.enable && FormMixSubmitData.sessionDates.includes(mealItem.date)"
                  :key="index"
                  class="mealList__item"
                >
                  <p class="color-primary">
                    {{ formatDate(mealItem.date, 'yyyy年MM月dd日') }}
                  </p>
                  <p
                    v-if="!!mealItem.meal.description"
                    class="text-gray-5"
                  >
                    {{ mealItem.meal.description }}
                  </p>
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="`${mealItem.date}餐食`"
                    rules="require"
                  >
                    <el-form-item
                      :prop="mealItem.date"
                      :error="errors[0]"

                    >
                      <el-radio-group
                        v-model="FormMixSubmitData.meals[mealItem.meal.id]"
                        class="isStyleOutlinButton isColumn"
                      >
                        <el-radio
                          v-for="(option, index2) in mealItem.meal.options"
                          :key="index2"
                          :label="option"
                          border
                        >
                          {{ option }}
                        </el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </ValidationProvider>
                </div>
              </template>
            </div>
          </div>
        </div>
        <BaseButton
          type="submit"
          :loading="loading"
          class="isStylePrimary isRadius isFull"
          :disabled="invalid"
        >
          下一步
        </BaseButton>
        <BaseButton
          class="isStylePrimary isOutline2 mt-4 isRadius isFull"
          @click="onPrev"
        >
          回上一步
        </BaseButton>
        <BaseButton
          class="isStylePrimary isOutline2 mt-4 isRadius isFull"
          :to="{ name: 'brand-event-item' }"
        >
          回活動介紹頁
        </BaseButton>
      </div>
    </el-form>

  </ValidationObserver>
</template>
<style lang="scss" module>
  // stylelint-disable selector-class-pattern
  .formApplyStep1 {
    :global {
      .formApplyStep1 {
        @include unstyled;
      }
    }
  }

  .mealList {
    :global {
      .mealList {
        &__item {
          &:not(:last-child) {
            border-bottom: $color-gray-3 1px solid;
            margin-bottom: 2rem;
          }
        }
      }
    }
  }
</style>
